import React from 'react';
import { Link } from 'wouter';
import { Flame, Shield } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="mt-28 border-t border-white/[0.08] bg-[#07080b] text-[#a9a396]">
      <div className="editorial-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-16">
          {/* Brand Col */}
          <div className="space-y-4 md:col-span-1">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-[#14161f] border border-[#d4af37]/40 flex items-center justify-center text-[#fae082]">
                <Flame className="w-4 h-4 text-amber-400" />
              </div>
              <span className="font-heading font-black text-lg text-white tracking-wider">
                DUNGEON DUDES
              </span>
            </div>
            <p className="text-sm text-[#8a857b] leading-relaxed">
              Das offizielle digitale Kompendium und Archiv für das browserbasierte Dark-Fantasy-RPG <strong>Dungeon Dudes</strong>. Vollständig synchronisiert mit den Quelldaten des Spiels.
            </p>
            <div className="flex items-center gap-2 text-xs text-amber-400/90 font-medium">
              <Shield className="w-4 h-4 text-amber-400" />
              <span>100% Kanonisch · Keine spekulativen Daten</span>
            </div>
          </div>

          {/* Quick links: Welt & Lore */}
          <div>
            <h4 className="text-sm font-heading font-bold uppercase tracking-wider text-white mb-4">
              Welt & Reiche
            </h4>
            <ul className="space-y-2.5 text-sm text-[#8a857b]">
              <li><Link href="/world/grimmburg" className="hover:text-amber-300 transition-colors">Grimmburg (Stufe 1–50)</Link></li>
              <li><Link href="/world/frostgipfel" className="hover:text-amber-300 transition-colors">Frostgipfel (Stufe 50–80)</Link></li>
              <li><Link href="/world/vulkangrat" className="hover:text-amber-300 transition-colors">Vulkangrat (Stufe 80–100)</Link></li>
              <li><Link href="/world/kronfels" className="hover:text-amber-300 transition-colors">Kronfels (Stufe 100–120)</Link></li>
              <li><Link href="/story" className="hover:text-amber-300 transition-colors">Die Chroniken der Grimmen Laterne</Link></li>
            </ul>
          </div>

          {/* Quick links: Kompendium */}
          <div>
            <h4 className="text-sm font-heading font-bold uppercase tracking-wider text-white mb-4">
              Kompendium
            </h4>
            <ul className="space-y-2.5 text-sm text-[#8a857b]">
              <li><Link href="/bestiary" className="hover:text-amber-300 transition-colors">Bestiarium & Bosse</Link></li>
              <li><Link href="/dungeons" className="hover:text-amber-300 transition-colors">Dungeons & Katakomben</Link></li>
              <li><Link href="/characters" className="hover:text-amber-300 transition-colors">Charaktere & NPCs</Link></li>
              <li><Link href="/items" className="hover:text-amber-300 transition-colors">Gegenstände & Rüstungen</Link></li>
              <li><Link href="/sets" className="hover:text-amber-300 transition-colors">Legendäre Ausrüstungssets</Link></li>
              <li><Link href="/quests" className="hover:text-amber-300 transition-colors">Quest-Archiv</Link></li>
            </ul>
          </div>

          {/* Technology & PWA */}
          <div>
            <h4 className="text-sm font-heading font-bold uppercase tracking-wider text-white mb-4">
              Begleiter-App (PWA)
            </h4>
            <p className="text-sm text-[#8a857b] leading-relaxed mb-4">
              Dieses Kompendium ist als vollwertige Progressive Web App optimiert und kann direkt auf Smartphones, Tablets oder Desktop installiert werden.
            </p>
            <div className="p-3.5 bg-[#0e1117] rounded-lg text-xs space-y-1.5 text-[#8a857b] border border-white/[0.06]">
              <div className="flex justify-between font-mono">
                <span>Einträge im Archiv:</span>
                <span className="text-amber-400 font-semibold">1.405 Datensätze</span>
              </div>
              <div className="flex justify-between font-mono">
                <span>Dokumentierte Reiche:</span>
                <span className="text-white font-semibold">4 spielbar · 3 Grenzlande</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom copyright / disclaimer */}
        <div className="pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#6e685f]">
          <p>© {new Date().getFullYear()} Dungeon Dudes Wiki. Alle Spieldaten, Grafiken und Texte sind Eigentum des Dungeon Dudes Projekts.</p>
          <div className="flex items-center gap-6">
            <Link href="/world" className="hover:text-white transition-colors">Weltkarte</Link>
            <Link href="/story" className="hover:text-white transition-colors">Chronik</Link>
            <Link href="/bestiary" className="hover:text-white transition-colors">Bestiarium</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
